import { formatThb } from "@bloom/utils";
import { cn } from "../cn.ts";

export interface PriceBadgeProps {
  amountThb: number;
  strikeAmountThb?: number; // shown when a promo is active
  locale?: "th" | "en";
  className?: string;
}

export function PriceBadge({
  amountThb,
  strikeAmountThb,
  locale = "en",
  className,
}: PriceBadgeProps) {
  const hasPromo = typeof strikeAmountThb === "number" && strikeAmountThb > amountThb;
  return (
    <span className={cn("inline-flex items-baseline gap-1.5 font-mono", className)}>
      {hasPromo ? (
        <span className="text-xs text-[var(--brand-muted)] line-through" aria-hidden>
          {formatThb(strikeAmountThb, { locale })}
        </span>
      ) : null}
      <span className="text-sm font-semibold text-[var(--brand-ink)]">
        {formatThb(amountThb, { locale })}
      </span>
    </span>
  );
}
